/* sb-dc-bottombar-clear.js - keep the bottom bar out from under the Help
   button. 2026-09-12.

   Reported (feedback item 19): the bottom-left notice "Fix these, or confirm
   in the proof and order anyway" is partly covered by the floating Help
   button.

   MEASURED (live, 1470 x 798):
     #launcher (the Help widget's iframe)  x 20..129,  y 708..758,  z 999998
     footer.bottombar .bb-status           x 20..288,  y 751..784
   They overlap in both axes, and the widget sits at z-index 999998, so it
   wins. The customer sees the left end of the sentence sliced off.

   FIX: the status block is indented past the widget's column. Measured after:
   the text starts at x=162, clear of the launcher's right edge at 129.

   Why not move the Help button: it is a third-party widget placed site-wide.
   Nudging it here would fix this page and surprise someone on another one,
   and the widget owns its own position anyway.

   CLEAR is set from the launcher's real width where possible, so if the
   widget is restyled or swapped the indent follows it instead of going stale.
   Falls back to the measured 124px.

   CSS only - nothing about the bar's content or behaviour changes.

   Diagnostics: window.__dcBottomClear() */
(function () {
  'use strict';

  var FALLBACK = 124, ID = 'sbdc-bottomclear-css', TICK = 1500;
  var info = { clear: 0, applied: false, source: 'fallback' };
  window.__dcBottomClear = function () { return info; };

  function launcherWidth() {
    var el = document.getElementById('launcher');
    if (!el) return 0;
    var r = el.getBoundingClientRect();
    /* only the bottom-LEFT corner is in the way */
    if (r.width < 10 || r.bottom < window.innerHeight - 200 || r.left > 240) return 0;
    return Math.ceil(r.right + 14);
  }

  function apply() {
    var w = launcherWidth();
    var clear = w || FALLBACK;
    info.source = w ? 'launcher' : 'fallback';
    if (clear === info.clear) return;
    info.clear = clear;

    var st = document.getElementById(ID);
    if (!st) {
      st = document.createElement('style');
      st.id = ID;
      (document.head || document.documentElement).appendChild(st);
    }
    st.textContent =
      '.bottombar .bb-status{padding-left:' + clear + 'px;}' +
      /* on a narrow window the bar stacks; the widget still owns the corner */
      '@media (max-width:749px){.bottombar .bb-status{padding-left:' + Math.min(clear, 96) + 'px;}}';
    info.applied = true;
  }

  function start() {
    apply();
    setInterval(apply, TICK);        // the widget loads late and can resize
    window.addEventListener('resize', apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
